type WebVitalsCallback = (metric: unknown) => void;

const reportWebVitals = (onPerfEntry?: WebVitalsCallback) => {
  if (typeof onPerfEntry === "function") {
    import("web-vitals")
      .then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
        getCLS(onPerfEntry);
        getFID(onPerfEntry);
        getFCP(onPerfEntry);
        getLCP(onPerfEntry);
        getTTFB(onPerfEntry);
      })
      .catch(() => {
        // no-op: metrics are optional
      });
  }
};

export default reportWebVitals;
